// extracted by mini-css-extract-plugin
export default {"reducedVerticalPadding":"Radio_reducedVerticalPadding__m3nsl"};